import authConstants from '@/v2/domains/Auth/constants/constants';

export function getUserType(user) {
  let type = '';
  if (user?.student) {
    type = authConstants.userType.student;
  } else if (user?.teacher) {
    type = authConstants.userType.teacher;
  } else if (user?.admin) {
    type = authConstants.userType.admin;
  }
  return type;
}
